import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router';
import styled from 'styled-components';

import { PrefetchLink } from '@sorare/routing';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandL, LabelL } from '@sorare/core/src/atoms/typography';
import { OnboardingButton } from '@sorare/core/src/components/onboarding/OnboardingButton';
import {
  FOOTBALL_ONBOARDING_CHOOSE_COMPETITION,
  FOOTBALL_ONBOARDING_TUTORIAL_PLAY,
} from '@sorare/core/src/constants/__generated__/routes';
import { glossary } from '@sorare/core/src/lib/glossary';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { MarketGuidanceLayout } from '#src/components/onboarding/MarketGuidanceLayout/index.tsx';
import { WinItems } from '#src/components/onboarding/WinItems/index.tsx';

const Root = styled(Vertical).attrs({ gap: 2 })`
  justify-content: space-between;
  flex: 1;
  width: 100%;

  @media ${tabletAndAbove} {
    width: auto;
  }
`;

const TutorialWinPage = () => {
  const navigate = useNavigate();

  const onContinue = async () => {
    navigate(FOOTBALL_ONBOARDING_CHOOSE_COMPETITION);
  };

  return (
    <MarketGuidanceLayout
      progress={40}
      center
      backUrl={FOOTBALL_ONBOARDING_TUTORIAL_PLAY}
      cta={
        <OnboardingButton size="large" color="secondary" onClick={onContinue}>
          <FormattedMessage {...glossary.continue} />
        </OnboardingButton>
      }
      ctaBackgroundColor="#0c0524"
    >
      <PrefetchLink to={FOOTBALL_ONBOARDING_CHOOSE_COMPETITION} />
      <Root>
        <Vertical gap={1.5} center>
          <FormattedMessage
            id="TutorialWinPage.title"
            defaultMessage="<em>Win</em><label>amazing rewards each Game Week</label>"
            values={{
              em: chunks => <BrandL>{chunks}</BrandL>,
              label: chunks => <LabelL>{chunks}</LabelL>,
            }}
          />
        </Vertical>
        <WinItems />
      </Root>
    </MarketGuidanceLayout>
  );
};
export default TutorialWinPage;
